module.exports = __webpack_public_path__ + "static/media/replay-blue.3d7b4741.svg";